import Vapi from 'vuex-rest-api';

const fetcherAdminFeed = new Vapi({
  state: {
    fetcherAdminFeed: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminFeed',
    property: 'fetcherAdminFeed',
    path: ({ fid }) => `/api/fetcher/admin/feeds/${fid}`,
  })
  .getStore();

export default fetcherAdminFeed;
